const Line = () => {
  return <hr className="w-full  px-0 border-1 border-grey-800  "></hr>;
};

export default Line;
